/**
 * Drive-facing helpers for OnlyOffice — avoid Stimulus data-actions in Preact rows.
 * Delegates to the body-mounted doc-editor Stimulus controller when present.
 */

function docEditorController() {
  const app = window.Stimulus
  if (!app?.getControllerForElementAndIdentifier) return null
  return app.getControllerForElementAndIdentifier(document.body, 'doc-editor')
}

export async function openDriveEditor({ blobId, configUrl, filename }) {
  const ctrl = docEditorController()
  if (!ctrl) {
    console.error('[drive] doc-editor controller not found on body')
    return
  }
  await ctrl.open({
    preventDefault() {},
    params: { blobId, configUrl, filename }
  })
}

export async function openNewDriveFile({ fileType }) {
  const ctrl = docEditorController()
  if (!ctrl) {
    console.error('[drive] doc-editor controller not found on body')
    return
  }
  await ctrl.openNew({
    preventDefault() {},
    params: { fileType }
  })
}
